import { JWT } from '@/model/authen';
import { GoogleOauth2 } from '@/model/drive';

export function setToken(jwt: JWT) {
	localStorage.setItem(
		'token',
		JSON.stringify({ accessToken: jwt.accessToken, refreshToken: jwt.refreshToken })
	);
}

export function getToken() {
	const token = localStorage.getItem('token');
	if (token) {
		try {
			return JSON.parse(token) as JWT;
		} catch (error) {
			clearToken();
			return undefined;
		}
	}
	return undefined;
}

export function clearToken() {
	localStorage.removeItem('token');
}

export function setGoogleToken(token: GoogleOauth2) {
	localStorage.setItem('googleToken', JSON.stringify(token));
}

export function getGoogleToken() {
	const token = localStorage.getItem('googleToken');
	if (token) {
		try {
			return JSON.parse(token) as GoogleOauth2;
		} catch (error) {
			localStorage.removeItem('googleToken');
		}
	}
}
